var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "video-default-location-form-line" },
      [
        _c(
          "div",
          { staticClass: "video-default-location-form-item-not-grow" },
          [_vm._v("当前位置")]
        ),
        _vm._v(" "),
        _c("TextBox", {
          staticClass: "video-default-location-form-item-grow",
          attrs: {
            text: String(_vm.curPosition),
            "change-on-blur": "",
            readonly: "",
            linear: "",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "video-default-location-vertical-space" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "video-default-location-form-line" },
      [
        _c(
          "VButton",
          {
            staticClass: "video-default-location-form-item-grow",
            on: {
              click: function ($event) {
                return _vm.$emit("set-default-location", _vm.curPosition)
              },
            },
          },
          [_vm._v("\n      将当前位置设为默认值\n    ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "video-default-location-vertical-space" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "video-default-location-form-line" },
      [
        _c("TextBox", {
          staticClass: "video-default-location-form-item-grow",
          attrs: { linear: "", "change-on-blur": "" },
          on: { change: _vm.onLocationInput },
          model: {
            value: _vm.locationInput,
            callback: function ($$v) {
              _vm.locationInput = $$v
            },
            expression: "locationInput",
          },
        }),
        _vm._v(" "),
        _c("VButton", { on: { click: _vm.locateTo } }, [_vm._v(" 定位 ")]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "video-default-location-vertical-space" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "video-default-location-form-line" },
      [
        _c("TextBox", {
          staticClass: "video-default-location-form-item-grow",
          attrs: { linear: "", "change-on-blur": "" },
          on: { change: _vm.onOffsetInput },
          model: {
            value: _vm.offsetInput,
            callback: function ($$v) {
              _vm.offsetInput = $$v
            },
            expression: "offsetInput",
          },
        }),
        _vm._v(" "),
        _c("VButton", { on: { click: _vm.offsetTo } }, [_vm._v(" 偏移 ")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }